'use strict'

import * as BasUtil from '@basalte/bas-util'

angular
  .module('basalteApp')
  .controller('musicSceneCtrl', [
    '$scope',
    '$uiRouterGlobals',
    'SCENE_STATES',
    'BAS_HOME',
    'BAS_ROOMS',
    'BAS_ROOM',
    'BAS_SOURCES',
    'BAS_SOURCE',
    'CurrentRoom',
    'BasSceneStateHelper',
    'Sources',
    'BasSceneHelper',
    musicSceneCtrl
  ])

/**
 * @param $scope
 * @param $uiRouterGlobals
 * @param {SCENE_STATES} SCENE_STATES
 * @param {BAS_HOME} BAS_HOME
 * @param {BAS_ROOMS} BAS_ROOMS
 * @param {BAS_ROOM} BAS_ROOM
 * @param {BAS_SOURCES} BAS_SOURCES
 * @param {BAS_SOURCE} BAS_SOURCE
 * @param {CurrentRoom} CurrentRoom
 * @param {BasSceneStateHelper} BasSceneStateHelper
 * @param {Sources} Sources
 * @param {BasSceneHelper} BasSceneHelper
 */
function musicSceneCtrl (
  $scope,
  $uiRouterGlobals,
  SCENE_STATES,
  BAS_HOME,
  BAS_ROOMS,
  BAS_ROOM,
  BAS_SOURCES,
  BAS_SOURCE,
  CurrentRoom,
  BasSceneStateHelper,
  Sources,
  BasSceneHelper
) {
  var music = this

  let registeredSource = BAS_HOME.NO_SOURCE

  var _DEFAULT_VOLUME = 50

  /**
   * @type {BAS_HOME}
   */
  music.BAS_HOME = BAS_HOME

  /**
   * @type {BAS_SOURCES}
   */
  music.BAS_SOURCES = BAS_SOURCES

  /**
   * @type {BAS_SOURCE}
   */
  music.BAS_SOURCE = BAS_SOURCE

  /**
   * @type {BAS_ROOMS}
   */
  music.BAS_ROOMS = BAS_ROOMS

  /**
   * @type {BAS_ROOM}
   */
  music.BAS_ROOM = BAS_ROOM

  music.$uiRouterGlobals = $uiRouterGlobals

  /**
   * @type {number}
   */
  music.volume = _DEFAULT_VOLUME

  // noinspection JSUnusedGlobalSymbols
  /**
   * Angular UI-router callback
   */
  this.uiOnParamsChanged = _onParamsChanged

  music.selectVolume = selectVolume
  music.selectSource = selectSource
  music.selectSourceDetail = selectSourceDetail
  music.selectFavourites = selectFavourites
  music.selectFavouritesDetail = selectFavouritesDetail
  music.volumeChange = volumeChange

  init()

  function init () {

    $scope.$on('$destroy', _onDestroy)

    _syncVolumeFromStep()

    _setSourcesInterest()
  }

  function _onParamsChanged () {

    _syncVolumeFromStep()

    _setSourcesInterest()
  }

  /**
   * @param {boolean} [force]
   */
  function selectVolume (force) {

    var _step

    _step = BasSceneHelper.getStep($scope, $uiRouterGlobals)

    if (_step) {

      _step.toggleMusicVolume(music.volume, force)
    }
  }

  /**
   * @param {string} sourceUuid
   */
  function selectSource (sourceUuid) {

    var _step

    // Always update volume
    _saveVolumeIfEnabled()

    _step = BasSceneHelper.getStep($scope, $uiRouterGlobals)

    if (_step && _step.music) {

      if (_step.music.source === sourceUuid) {

        // Change source to off
        _step.setMusicSource('')

        _setSourcesInterest()

      } else if (sourceUuid && _step.music.source !== sourceUuid) {

        // Change source to this uuid
        _step.setMusicSource(sourceUuid)

        _setSourcesInterest()

      } else {

        // No source changes
        _step.setMusicSource('')

        _setSourcesInterest()
      }
    }
  }

  /**
   * @param {string} sourceUuid
   */
  function selectSourceDetail (sourceUuid) {

    var _step, _source

    // Always update volume
    _saveVolumeIfEnabled()

    _step = BasSceneHelper.getStep($scope, $uiRouterGlobals)

    if (_step && _step.music) {

      _source = BAS_SOURCES.SOURCES.sources[sourceUuid]

      if (
        _source &&
        (
          _source.type === BAS_SOURCE.T_PLAYER ||
          _source.type === BAS_SOURCE.T_ASANO
        )
      ) {

        _step.setMusicSource(sourceUuid)

        _setSourcesInterest()

        CurrentRoom.go(BasSceneStateHelper.getSceneState(
          SCENE_STATES.SCENE_STEP_MUSIC_FAVOURITES
        ))

      } else {

        selectSource(sourceUuid)
      }
    }
  }

  function selectFavourites () {

    var _step, _room, _defaultSource

    // Always update volume
    _saveVolumeIfEnabled()

    _step = BasSceneHelper.getStep($scope, $uiRouterGlobals)

    if (_step && _step.music) {

      _room = BasSceneHelper.getStepRoom(_step)

      if (_room && _room.music) {

        _defaultSource = _room.music.getDefaultSource()

        if (_defaultSource) {

          if (_step.music.source === _defaultSource) {

            // Un-toggle
            _step.setMusicSource('')
            _setSourcesInterest()

          } else {

            // Set default source
            _step.setMusicSource(_defaultSource)
            _setSourcesInterest()
          }

        } else {

          // Un-toggle
          _step.setMusicSource('')
          _setSourcesInterest()
        }
      }
    }
  }

  function selectFavouritesDetail () {

    var _step, _room, _defaultSource, _source

    // Always update volume
    _saveVolumeIfEnabled()

    _step = BasSceneHelper.getStep($scope, $uiRouterGlobals)

    if (_step && _step.music) {

      _room = BasSceneHelper.getStepRoom(_step)

      if (_room && _room.music) {

        _defaultSource = _room.music.getDefaultSource()

        _source = BAS_SOURCES.SOURCES.sources[_defaultSource]

        if (_source && _source.isAudioSource) {

          _step.setMusicSource(_defaultSource)
          _setSourcesInterest()

          CurrentRoom.go(BasSceneStateHelper.getSceneState(
            SCENE_STATES.SCENE_STEP_MUSIC_FAVOURITES
          ))
        }
      }
    }
  }

  function volumeChange () {

    var _step

    _step = BasSceneHelper.getStep($scope, $uiRouterGlobals)

    if (_step) {

      _step.setMusicVolume(music.volume)
    }
  }

  function _saveVolumeIfEnabled () {

    var _step

    _step = BasSceneHelper.getStep($scope, $uiRouterGlobals)

    if (_step && _step.music) {

      if (_step.music.volume !== -1) _step.setMusicVolume(music.volume)
    }
  }

  function _syncVolumeFromStep () {

    var _step, _room

    _step = BasSceneHelper.getStep($scope, $uiRouterGlobals)

    music.volume = _DEFAULT_VOLUME

    if (_step) {

      if (_step.music &&
        BasUtil.isPNumber(_step.music.volume, true)) {

        music.volume = _step.music.volume

      } else {

        if (_step.room) {

          _room = BAS_ROOMS.ROOMS.rooms[_step.room]

          if (_room && _room.music && _room.music.toggle) {

            music.volume = _room.music.startupVolume
          }
        }
      }
    }
  }

  function _setSourcesInterest () {

    const step = BasSceneHelper.getStep($scope, $uiRouterGlobals)

    if (step && step.music) {

      const source = BAS_SOURCES.SOURCES.sources[step.music.source]

      if (source) {

        const newSourceId = source.getId()

        if (registeredSource !== newSourceId) {

          Sources.unregisterFor(
            BAS_SOURCE.COL_EVT_FAVOURITES,
            registeredSource
          )

          registeredSource = newSourceId

          Sources.registerFor(
            BAS_SOURCE.COL_EVT_FAVOURITES,
            registeredSource
          )
        }

      } else {

        Sources.unregisterFor(
          BAS_SOURCE.COL_EVT_FAVOURITES,
          registeredSource
        )
        registeredSource = BAS_HOME.NO_SOURCE
      }

    } else {

      Sources.unregisterFor(
        BAS_SOURCE.COL_EVT_FAVOURITES,
        registeredSource
      )
      registeredSource = BAS_HOME.NO_SOURCE
    }
  }

  function _onDestroy () {

    Sources.unregisterFor(
      BAS_SOURCE.COL_EVT_FAVOURITES,
      registeredSource
    )
  }
}
